import $ from 'jquery';

import tableDragger from 'table-dragger';

class Sorter {

	constructor() {
		
		$(".sortable-table").each((i, table) => {

			var dragger = tableDragger(table, {
			  mode: 'row',
			  dragHandler: '.handle',
			  onlyBody: true,
			  animation: 300
			});
			dragger.on('drop',(from, to, el) => {

				let indexes = [];
				$(table).find("tbody tr").each((ii, tr) => {
					indexes.push($(tr).data("id"));
				});

				let name = $(table).data("table");

				$.ajax({
					data: {
						op: "sort",
						table: name,
						indexes: indexes
					}
				});

			});

		});

	}

}

export default Sorter;